import { render } from "./MyTimeline.vue?vue&type=template&id=30a7a05f&scoped=true"
import script from "./MyTimeline.vue?vue&type=script&lang=js"
export * from "./MyTimeline.vue?vue&type=script&lang=js"

import "./MyTimeline.vue?vue&type=style&index=0&id=30a7a05f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Marti\\Desktop\\Web Development\\portfolio-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a7a05f"]])

export default __exports__